import script from "./ModalCategoryList.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalCategoryList.vue?vue&type=script&setup=true&lang=js"

import "./ModalCategoryList.vue?vue&type=style&index=0&id=3098fcfc&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3098fcfc"]])

export default __exports__